var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGears = function SvgGears(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500.5 500.5",
    height: 500.5,
    width: 500.5,
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "invis gearShards",
    fillOpacity: 1,
    paintOrder: "stroke fill markers"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.35 134.985l48.448 48.449H155.35",
    fill: "#c49700",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.574 134.882v24.328l-24.225-24.225",
    fill: "#c49700",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.057 149.176v68.517l-34.259-34.259",
    fill: "#c49700",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.26 166.232l-17.203 17.202v-34.258",
    fill: "#c49700",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.506 217.693l-48.449 48.449v-48.449",
    fill: "#c49700",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.61 241.917h-24.33l24.225-24.224",
    fill: "#c49700",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.315 300.4h-68.517l34.259-34.258",
    fill: "#c49700",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.26 317.603L238.057 300.4h34.258",
    fill: "#c49700",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.798 348.849L155.35 300.4h48.448",
    fill: "#c49700",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.574 348.953v-24.328l24.224 24.224",
    fill: "#c49700",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.091 334.659v-68.517L155.35 300.4",
    fill: "#c49700",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.888 317.603l17.203-17.203v34.259",
    fill: "#c49700",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.642 266.142l48.449-48.449v48.449",
    fill: "#c49700",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.538 241.917h24.329l-24.225 24.225",
    fill: "#c49700",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.832 183.434h68.518l-34.259 34.259",
    fill: "#c49700",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.888 166.232l17.203 17.202H86.832",
    fill: "#c49700",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.091 217.693v24.224l17.13-41.353z",
    fill: "#c49700",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.35 183.434l-17.13 17.13 41.354-17.13z",
    fill: "#c49700",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.798 183.434h-24.224l41.353 17.13z",
    fill: "#c49700",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.057 217.693l-17.13-17.13 17.13 41.354z",
    fill: "#c49700",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.057 266.142v-24.225l-17.13 41.354z",
    fill: "#c49700",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.798 300.4l17.13-17.129-41.354 17.129z",
    fill: "#c49700",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.35 300.4h24.224l-41.354-17.129z",
    fill: "#c49700",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.091 266.142l17.129 17.129-17.129-41.354z",
    fill: "#c49700",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.732 334.982l24.224-24.225 24.225 24.225",
    fill: "#a50000",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.732 286.533l24.224 24.224-24.224 24.225",
    fill: "#a50000",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.956 286.429v24.328l-24.224-24.224",
    fill: "#a50000",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.18 334.982h34.26v34.258",
    fill: "#a50000",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.44 300.723v34.259h-34.26",
    fill: "#a50000",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.642 317.779l-17.203 17.203v-34.259",
    fill: "#a50000",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.44 369.24l24.224 24.224-24.225 24.225",
    fill: "#a50000",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.888 369.24l-24.224 24.224-24.225-24.224",
    fill: "#a50000",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.992 393.464h-24.328l24.224-24.224",
    fill: "#a50000",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.44 417.689v34.258h-34.26",
    fill: "#a50000",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.698 451.947h-34.259V417.69",
    fill: "#a50000",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.642 469.15l-17.203-17.203h34.259",
    fill: "#a50000",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.18 451.947l-24.224 24.225-24.224-24.225",
    fill: "#a50000",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.18 500.396l-24.224-24.224 24.225-24.225",
    fill: "#a50000",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.956 500.5v-24.328l24.225 24.224",
    fill: "#a50000",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.732 451.947h-34.259V417.69",
    fill: "#a50000",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.473 486.206v-34.259h34.259",
    fill: "#a50000",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.27 469.15l17.203-17.203v34.259",
    fill: "#a50000",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.473 417.689l-24.224-24.225 24.224-24.224",
    fill: "#a50000",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.024 417.689l24.225-24.225 24.224 24.225",
    fill: "#a50000",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.92 393.464h24.329l-24.225 24.225",
    fill: "#a50000",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.473 369.24v-34.259h34.259",
    fill: "#a50000",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.215 334.982h34.258v34.258",
    fill: "#a50000",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.27 317.779l17.203 17.203h-34.258",
    fill: "#a50000",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.961 48.553l24.224-24.225 24.225 24.225",
    fill: "#ff6900",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.961.104l24.224 24.224-24.224 24.225",
    fill: "#ff6900",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.185 0v24.328L307.961.104",
    fill: "#ff6900",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.41 48.553h34.258V82.81",
    fill: "#ff6900",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.668 14.294v34.259H356.41",
    fill: "#ff6900",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.871 31.35l-17.203 17.203V14.294",
    fill: "#ff6900",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.668 82.811l24.225 24.225-24.225 24.224",
    fill: "#ff6900",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.117 82.811l-24.224 24.225-24.225-24.225",
    fill: "#ff6900",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.221 107.036h-24.328l24.224-24.225",
    fill: "#ff6900",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.668 131.26v34.259H356.41",
    fill: "#ff6900",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.927 165.519h-34.259V131.26",
    fill: "#ff6900",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.871 182.721l-17.203-17.203h34.259",
    fill: "#ff6900",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.41 165.518l-24.225 24.225-24.224-24.225",
    fill: "#ff6900",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.41 213.967l-24.225-24.224 24.225-24.225",
    fill: "#ff6900",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.185 214.071v-24.328l24.225 24.224",
    fill: "#ff6900",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.961 165.518h-34.259V131.26",
    fill: "#ff6900",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.702 199.777v-34.259h34.259",
    fill: "#ff6900",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 182.721l17.202-17.202v34.258",
    fill: "#ff6900",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.702 131.26l-24.224-24.224 24.224-24.225",
    fill: "#ff6900",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.254 131.26l24.224-24.224 24.224 24.224",
    fill: "#ff6900",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.15 107.036h24.328l-24.224 24.224",
    fill: "#ff6900",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.702 82.811V48.553h34.259",
    fill: "#ff6900",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.444 48.553h34.258V82.81",
    fill: "#ff6900",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 31.35l17.202 17.203h-34.258",
    fill: "#ff6900",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.942 73.77l10.019-25.217h48.449z",
    fill: "#ff6900",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.493 59.3l24.917-10.747 34.258 34.258z",
    fill: "#ff6900",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.45 72.792l25.218 10.019v48.449z",
    fill: "#ff6900",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.92 106.34l10.748 24.92-34.258 34.258z",
    fill: "#ff6900",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.428 140.301l-10.018 25.217h-48.45z",
    fill: "#ff6900",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.879 154.77l-24.918 10.748-34.259-34.258z",
    fill: "#ff6900",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.918 141.278l-25.216-10.018V82.811z",
    fill: "#ff6900",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.45 107.73l-10.749-24.92 34.259-34.258z",
    fill: "#ff6900",
    strokeWidth: 0.618,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.186 107.036V82.81l17.129 7.095z",
    fill: "#ff6900",
    strokeWidth: 0.237,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.186 107.036l17.129-17.13 7.095 17.13z",
    fill: "#ff6900",
    strokeWidth: 0.237,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.186 107.036h24.224l-7.095 17.129z",
    fill: "#ff6900",
    strokeWidth: 0.237,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.186 107.036l17.129 17.129-17.13 7.095z",
    fill: "#ff6900",
    strokeWidth: 0.237,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.186 107.036v24.224l-17.13-7.095z",
    fill: "#ff6900",
    strokeWidth: 0.237,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.186 107.036l-17.13 17.129-7.095-17.13z",
    fill: "#ff6900",
    strokeWidth: 0.237,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.186 107.036H307.96l7.095-17.13z",
    fill: "#ff6900",
    strokeWidth: 0.237,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.186 107.036l-17.13-17.13 17.13-7.095z",
    fill: "#ff6900",
    strokeWidth: 0.237,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.18 334.982l-24.224 58.482 58.484-24.224z",
    fill: "#a50000",
    strokeWidth: 0.979,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.44 369.24l-58.484 24.224 58.484 24.225z",
    fill: "#a50000",
    strokeWidth: 0.979,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.44 417.689l-58.484-24.225 24.224 58.483z",
    fill: "#a50000",
    strokeWidth: 0.979,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.732 451.947l24.224-58.483-58.483 24.226z",
    fill: "#a50000",
    strokeWidth: 0.979,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.473 369.24l58.483 24.224-24.224-58.482z",
    fill: "#a50000",
    strokeWidth: 0.979,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.732 451.947h48.448l-24.224-58.483z",
    fill: "#a50000",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.473 417.69v-48.45l58.483 24.224z",
    fill: "#a50000",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.732 334.982l24.224 58.482 24.224-58.482z",
    fill: "#a50000",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.091 241.917l58.483 58.483-41.354-17.129z",
    fill: "#c49700",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.574 300.4l58.483-58.483-17.13 41.354z",
    fill: "#c49700",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.574 183.434l58.483 58.483-17.13-41.353z",
    fill: "#c49700",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.574 183.434l-58.483 58.483 17.13-41.353z",
    fill: "#c49700",
    stopColor: "#000"
  }))));
};
export default SvgGears;